import script from "./ParkRules.vue?vue&type=script&setup=true&lang=js"
export * from "./ParkRules.vue?vue&type=script&setup=true&lang=js"

import "./ParkRules.vue?vue&type=style&index=0&id=3cf63416&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf63416"]])

export default __exports__